/** campaign-leads RENDERER — overview page + LEADS directory (name + role).
 *  Shares the standard campaign renderer: identical to campaign-overview's
 *  directory, but built for the leads-basic template's own conf/identity. */
import { renderCampaignReport } from '../campaign-overview/render';
import type { CampaignReport } from '../../schema/campaign';

export const renderCampaignLeadsReport = renderCampaignReport;
